import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import { toSelectList, getRubs, formatDate } from '../functions';
import { dashboardsTitles } from '../dictionary';

import { TableReportPage } from './PageTemplates';
import { AddButton, FilterIconButton, ItemNewHeader, MainFilterBlock, RemoveIconButton } from '../shared/PageComponents';
import { Selectize, TextInput, DateInput } from '../forms/FormItems';
import { EmptyResultInformer, OpenShiftInformer } from '../shared/FeedbackComponents';
import { DocumentInfoRow, DocumentStatusInfo } from '../shared/StockComponents';
import { SparkleIcon } from '../images/icons';

import { WriteOffState, WriteOffRequestState } from '../stores/writeoffs';
import { CancelReasonApi, ProductApi, WriteOffApi, WriteOffRequestApi } from '../stores/apiMethods';
import { confirmState } from '../stores/common';

/** Страница создания заявки и обработки заявок на списание */
export class WriteOffRequestsPage extends Component {
	constructor(props) {
		super(props);

		this.store = new WriteOffRequestState();
	}

	/** Загрузка справочников причин списания и товаров */
	componentDidMount() {
		CancelReasonApi.getList((data) => {
			this.store.CancelReasonList = data.Success ? data.CancelReasons : [];
		});
		ProductApi.getList({ Active: true }, (data) => {
			this.store.ProductList = data.Success ? data.Products : [];
		});
		if (this.store.WriteOff.ProcessingMode && this.store.WriteOff.StockId > 0) this.getItem();
	}

	/** Загрузка формируемого списания выбранного склада */
	getItem() {
		WriteOffApi.getByStockId(this.store.WriteOff.StockId, (data) => {
			this.store.setWriteOff(data.Success ? data : undefined);
			this.getRequests();
		});
	}

	/** Загрузка ожидающих заявок выбранного склада */
	getRequests() {
		WriteOffRequestApi.getList({ StockId: this.store.WriteOff.StockId, Status: 1 }, (data) => {
			this.store.WriteOff.setProductsFromRequests(
				data.Success && !_.isNull(data.Requests) ? data.Requests : []
			);
		});
	}

	/** Отправка формы по сценарию текущего режима */
	handleSubmit(event) {
		event.preventDefault();

		if (!this.store.WriteOff.validate()) return false;
		this.store.WriteOff.ButtonLoading = true;

		if (this.store.WriteOff.ProcessingMode) {
			this.saveWriteOff(event.nativeEvent.submitter.dataset.action === "accept" ? "send" : undefined);
		} else this.createRequest();
	}

	/** Создание новой заявки на списание */
	createRequest() {
		WriteOffRequestApi.create(this.store.WriteOff.getData(), (data) => {
			this.store.WriteOff.ErrorCode = data.Success ? "SUCCESS_SAVE" : data.ErrorCode;
			this.store.WriteOff.SuccessSave = data.Success;
			this.store.WriteOff.ButtonLoading = false;

			if (data.Success) setTimeout(() => { this.store.setRequest(); }, 1000);
		});
	}

	/**
	 * Сохранение формируемого списания
	 * @param {string} type - дополнительное действие после сохранения
	 */
	saveWriteOff(type) {
		WriteOffApi.save(this.store.WriteOff.getData(), (data) => {
			if (data.Success) {
				if (type === "send") {
					this.store.WriteOff.Id = data.Id;
					this.sendWriteOff();
				} else this.getItem();
			}

			this.store.WriteOff.ErrorCode = data.Success ? "SUCCESS_SAVE" : data.ErrorCode;
			this.store.WriteOff.SuccessSave = data.Success;
			this.store.WriteOff.ButtonLoading = data.Success && type !== "send";
		});
	}

	/** Отправка сохранённого списания */
	sendWriteOff() {
		WriteOffApi.send(this.store.WriteOff.Id, (data) => {
			if (data.Success) setTimeout(() => { this.getItem(); }, 500);

			this.store.WriteOff.ErrorCode = data.Success ? "SUCCESS_SEND" : data.ErrorCode;
			this.store.WriteOff.SuccessSave = data.Success;
			this.store.WriteOff.ButtonLoading = false;
		});
	}

	render() {
		return (
			<div className="page" id="WriteOffRequestsPage">
				<div className="item" id="WriteOffRequestItem">
					<form onSubmit={this.handleSubmit.bind(this)}>
						<ItemNewHeader
							Title={this.store.WriteOff.ProcessingMode ? "Заявка на списание" : "Новая заявка на списание"}
							ErrorCode={this.store.WriteOff.ErrorCode}
							ButtonLoading={this.store.WriteOff.ButtonLoading}
							CanManage={this.store.CanSave}
							CanAccept={this.store.ShiftActive && this.store.WriteOff.ProcessingReady}
							AcceptTitle="Сохранить и отправить"
							SuccessSave={this.store.WriteOff.SuccessSave}
							HideClose={true}
						/>
						{!this.store.ShiftActive &&
							<OpenShiftInformer Text="Для работы с заявками откройте смену" />
						}
						{this.store.ShiftActive &&
							<>
								<MainSettings
									store={this.store}
									getItem={this.getItem.bind(this)}
								/>
								{this.store.WriteOff.StockId > 0 &&
									<ProductsBlock store={this.store} />
								}
							</>
						}
					</form>
				</div>
			</div>
		)
	}
}
WriteOffRequestsPage = observer(WriteOffRequestsPage);

/** Настройки склада и даты списания */
class MainSettings extends Component {
	/**
	 * Сбор выбранного склада и загрузка связанных с ним данных
	 * @param {string} id - имя поля модели
	 * @param {number} value - идентификатор склада
	 */
	handleChange(id, value) {
		this.props.store.WriteOff.collect(id, value);
		if (this.props.store.WriteOff.ProcessingMode) this.props.getItem();
	}

	render() {
		return(
			<div className="section settings">
				<Selectize
					Id="StockId"
					Title="Склад"
					List={this.props.store.Stocks}
					Value={this.props.store.WriteOff.StockId}
					isSearchable={false}
					onChange={(value, id) => this.handleChange(id, value)}
				/>
				{this.props.store.WriteOff.ProcessingReady && this.props.store.CanAccept &&
					<DateInput
						Id="Date"
						Title="Дата списания"
						WithTime={true}
						Value={this.props.store.WriteOff.Date}
						onChange={(value, id) => this.props.store.WriteOff.collect(id, value)}
					/>
				}
			</div>
		)
	}
}
MainSettings = observer(MainSettings);

/** Группы товаров заявки или формируемого списания */
class ProductsBlock extends Component {
	render() {
		return(
			<>
				{_.map(this.props.store.WriteOff.Products, (group) => {
					return(
						<div className="section" key={"type" + group.Id}>
							<h4>{group.Name}</h4>
							<ProductTypeBlock
								key={"wt" + group.Id}
								ProductsList={_.filter(this.props.store.ProductList, { Type : group.Id })}
								Products={group.List}
								CancelReasons={this.props.store.CancelReasonList}
								ProductType={group.Id}
								View={this.props.store.WriteOff.Status === 3}
								ShowAmount={this.props.store.ShowAmount}
								store={this.props.store.WriteOff}
							/>
							{this.props.store.WriteOff.Status !== 3 &&
								<AddButton Title="Добавить продукт"
									onClick={() => this.props.store.WriteOff.addProduct(group.Id)} />
							}
						</div>
					)
				})}
			</>
		)
	}
}
ProductsBlock = observer(ProductsBlock);

class ProductTypeBlock extends Component {
	render() {
		return (
			<div className={"products" + (this.props.ShowAmount ? " withAmount" : "")}>
				<ProductTitles ShowAmount={this.props.ShowAmount} />
				{_.map(this.props.Products, (product, i) => {
					var previousProduct = this.props.Products[i - 1],
						cancelReason = _.find(this.props.CancelReasons, {
							Id: parseInt(product.CancelReasonId, 10)
						}),
						showCancelReason = this.props.store.ProcessingMode &&
							product.CancelReasonId !== -1 && product.CancelReasonId !== "" &&
							(!previousProduct ||
								parseInt(previousProduct.CancelReasonId, 10) !==
									parseInt(product.CancelReasonId, 10));

					return(
						<React.Fragment key={"p_" + this.props.ProductType + "_" + i}>
							{showCancelReason &&
								<span className="cancelReasonTitle title">
									{cancelReason ? cancelReason.Name : ""}
								</span>
							}
							{this.props.View
								? <ProductViewItem Item={product} ShowAmount={this.props.ShowAmount} />
								: <ProductEditItem
									Index={i}
									Item={product}
									Products={this.props.ProductsList}
									CancelReasons={this.props.CancelReasons}
									ProductType={this.props.ProductType}
									store={this.props.store}
								/>
							}
						</React.Fragment>
					)
				})}
				
			</div>
		)
	}
}
ProductTypeBlock = observer(ProductTypeBlock);


export class WriteOffsPage extends Component {
	constructor(props) {
		super(props);

		this.store = new WriteOffState();

		this.state = {
			isOpen: false
		};
	}

	/** Загрузка списка списаний и справочников страницы */
	componentDidMount() {
		this.getData();
		CancelReasonApi.getList((data) => {
			this.store.CancelReasonList = data.Success ? data.CancelReasons : [];
		});
		ProductApi.getList({ Active : true }, (data) => {
			this.store.ProductList = data.Success ? data.Products : [];
		});
	}

	/** Загрузка списка списаний по текущим параметрам фильтра */
	getData() {
		this.store.IsSendRequest = false;
		WriteOffApi.getList(this.store.Filter.getData(), (data) => { this.store.setWriteOffs(data); });
	}

	/**
	 * Загрузка выбранного списания
	 * @param {number} id идентификатор списания
	 */
	getItem(id) {
		WriteOffApi.getById(id, (data) => {
			this.store.setWriteOff(data.Success ? data : undefined);
		});
	}

	/**
	 * Переключение между списком и карточкой списания
	 * @param {number|undefined} id идентификатор списания, -1 для новой карточки
	 * или undefined для возврата к списку
	 */
	setId(id) {
		if (!_.isUndefined(id)) {
			if (id !== -1) this.getItem(id)
			else this.store.setWriteOff({ Id: -1 });
		} else {
			this.store.setWriteOff(undefined);
			this.getData();
		}
	}

	/**
	 * Переход на страницу списка с указанного смещения
	 * @param {number} offset смещение записей списка
	 */
	changePage(offset) {
		this.store.Filter.Offset = offset;
		this.getData();
	}

	render() {
		return (
			<div className="page" id="WriteOffPage">
				{_.isUndefined(this.store.WriteOff) &&
					<div className="head">
						<div>
							<h2>{dashboardsTitles[this.props.Type]}</h2>
							<FilterIconButton IsOpen={this.state.isOpen}
								onClick={() => this.setState({ isOpen: !this.state.isOpen })} />
						</div>
						<FilterBlock
							store={this.store}
							IsOpen={this.state.isOpen}
							getData={this.getData.bind(this)}
						/>
					</div>
				}
				{!_.isEmpty(this.store.WriteOffs) && _.isUndefined(this.store.WriteOff) &&
					<TableReportPage
						TableData={this.store.WriteOffs}
						Type="WriteOffs"
						TableColumns={this.store.columns}
						FilterHeight={this.state.isOpen ? 125 : 0}
						Pagination={true}
						Limit={this.store.Filter.Limit}
						HasMore={this.store.HasMore}
						Offset={this.store.Filter.Offset}

						changePage={this.changePage.bind(this)}
						editRow={this.setId.bind(this)}

						getTrProps={(state, rowInfo, column) => ({
							className: rowInfo.original.RowClass
						})}
					/>
				}
				{this.store.IsSendRequest && _.isEmpty(this.store.WriteOffs) &&
					<EmptyResultInformer />
				}
				{!_.isUndefined(this.store.WriteOff) &&
					<WriteOffItem
						CancelReasons={this.store.CancelReasonList}
						Products={this.store.ProductList}
						store={this.store}

						setId={this.setId.bind(this)}
						getItem={this.getItem.bind(this)}
					/>
				}
			</div>
		)
	}
}
WriteOffsPage = observer(WriteOffsPage);

/** Фильтр списка списаний */
class FilterBlock extends Component {
	/** Отправка формы */
	handleSubmit = () => {
		this.props.store.Filter.Offset = 0;
		this.props.getData();
	}

	render() {
		return(
			<MainFilterBlock Filter={this.props.store.Filter} IsOpen={this.props.IsOpen}
				IsPartialOpen={false} onSubmit={this.handleSubmit}>
				<Selectize
					Id="StockId"
					Title="Склад"
					List={this.props.store.Stocks}
					Value={this.props.store.Filter.StockId}
					isSearchable={false}
					onChange={(value, id) => this.props.store.Filter.collect(id, value)}
				/>
				<Selectize
					Id="Status"
					Title="Статус"
					isSearchable={false}
					List={toSelectList(this.props.store.Statuses)}
					Value={this.props.store.Filter.Status}
					onChange={(value, id) => this.props.store.Filter.collect(id, value)}
				/>
			</MainFilterBlock>
		)
	}
}
FilterBlock = observer(FilterBlock);

class WriteOffItem extends Component {
	/** Проверка модели и запуск выбранного действия формы */
	handleSubmit(event) {
		event.preventDefault();

		if (event.nativeEvent.submitter &&
			event.nativeEvent.submitter.dataset.action === "accept") {
			this.handleAccept(event);
			return;
		}

		if (!this.props.store.WriteOff.validate()) return false;
		this.saveWriteOff();
	}

	/** Открытие подтверждения списания */
	handleAccept(event) {
		event.preventDefault();

		var date = formatDate(this.props.store.WriteOff.Date),
			text = <span>Вы действительно хотите подтвердить списание от&nbsp;<b key="b1">«{date}»</b>?</span>;

		confirmState.openConfirm(text, () => { this.saveWriteOff("accept"); });
	}

	/**
	 * Сохранение списания и дополнительное подтверждение при необходимости
	 * @param {string} type - дополнительное действие после сохранения
	 */
	saveWriteOff (type) {
		this.props.store.WriteOff.ButtonLoading = true;

		WriteOffApi.save(this.props.store.WriteOff.getData(), (data) => {
			if (data.Success) {
				if (type === "accept") {
					var id = data.Id;
					WriteOffApi.accept(data.Id, (data) => {
						if (data.Success) this.props.getItem(id);

						this.props.store.WriteOff.ErrorCode =
							data.Success ? "SUCCESS_ACCEPT" : data.ErrorCode;
						this.props.store.WriteOff.SuccessSave = data.Success;
						this.props.store.WriteOff.ButtonLoading = false;
					});
				} else this.props.getItem(data.Id);
			}

			this.props.store.WriteOff.ErrorCode = data.Success ? "SUCCESS_SAVE" : data.ErrorCode;
			this.props.store.WriteOff.SuccessSave = data.Success;
			this.props.store.WriteOff.ButtonLoading = type !== "accept";
		});
	}

	render() {
		return (
			<section className="item" id="WriteOffRequestItem">
				<form onSubmit={this.handleSubmit.bind(this)}>
					<ItemNewHeader
						Title={this.props.store.PageTitle}
						ErrorCode={this.props.store.WriteOff.ErrorCode}
						ButtonLoading={this.props.store.WriteOff.ButtonLoading}
						CanManage={this.props.store.CanManage && this.props.store.WriteOff.Status === 2}
						CanAccept={this.props.store.CanAccept && this.props.store.WriteOff.Status === 2}
						SuccessSave={this.props.store.WriteOff.SuccessSave}
						handleClose={this.props.setId.bind(this, undefined)}
					/>
					<StatusInfoBlock store={this.props.store} />
					<ProductsBlock store={this.props.store} />
				</form>
			</section>
		)
	}
}
WriteOffItem = observer(WriteOffItem);

class StatusInfoBlock extends Component {
	render() {
		return(
			<div className="info">
				<DocumentStatusInfo
					Active={true}
					ActiveTitle="Создано"
					User={this.props.store.WriteOff.User}
					Date={formatDate(this.props.store.WriteOff.ShiftDate)}
					ClassName="create"
				>
					<DocumentInfoRow Title="Склад">
						{this.props.store.WriteOff.Stock}
					</DocumentInfoRow>
					<DocumentInfoRow Title="Дата списания">
						{this.props.store.WriteOff.Status === 3 && <span className="col col60">
								{formatDate(this.props.store.WriteOff.Date, "DD.MM.YYYY HH:mm")}
							</span>}
						{this.props.store.WriteOff.Status === 2 && this.props.store.CanAccept &&
							<DateInput
								Id="Date"
								Value={this.props.store.WriteOff.Date}
								RowClass="nomargin"
								WithTime={true}
								onChange={(value, id) => this.props.store.WriteOff.collect(id, value)}
							/>
						}
					</DocumentInfoRow>
				</DocumentStatusInfo>
				<DocumentStatusInfo
					Active={this.props.store.WriteOff.SendDate !== ""}
					ActiveTitle="Отправлено"
					InactiveTitle="Не отправлено"
					User={this.props.store.WriteOff.SendUser}
					Date={formatDate(
						this.props.store.WriteOff.SendDate,
						"DD.MM.YYYY HH:mm"
					)}
				>
					{this.props.store.WriteOff.AutoSend &&
						<p className="automaticInfo">
							Списание было отправлено автоматически при автозакрытии смены
						</p>
					}
				</DocumentStatusInfo>
				<DocumentStatusInfo
					Active={this.props.store.WriteOff.Status === 3}
					ActiveTitle="Подтверждено"
					InactiveTitle="Не подтверждено"
					User={this.props.store.WriteOff.AcceptUser}
					Date={formatDate(this.props.store.WriteOff.AcceptDate)}
				>
					{this.props.store.ShowAmount &&
						<DocumentInfoRow Title="Сумма списания">
							{getRubs(this.props.store.WriteOff.Amount, true, true)} руб.
						</DocumentInfoRow>
					}
				</DocumentStatusInfo>
			</div>
		)
	}
}

class ProductTitles extends Component {
	render() {
		return(
			<>
				<span className="title action"></span>
				<span className="title">Продукт</span>
				<span className="title">Кол-во</span>
				<span className="title">Причина списания</span>
				<span className="title">Комментарий</span>
				{this.props.ShowAmount && <span className="title">Сумма</span>}
				<span className="title action"></span>
			</>
		)
	}
}

class ProductEditItem extends Component {
	/** Сбор продукта и связанной с ним единицы измерения 
	 * @param {string} id название параметра
	 * @param {string} value значение параметра
	*/
	handleProductChange(value, id) {
		var product = _.find(this.props.Products, { Id: value });

		this.props.Item.collect(id, value);
		this.props.Item.collect("UnitName", product ? product.UnitNet : "");
	}

	render() {
		return(
			<>
				<span className="newProductIcon" title={this.props.Item.New ? "Добавлено из заявки" : ""}>
					{this.props.Item.New && <SparkleIcon />}
				</span>
				<Selectize
					Id="ProductId"
					List={toSelectList(this.props.Products)}
					RowClass="nomargin"
					Value={this.props.Item.ProductId}
					onChange={this.handleProductChange.bind(this)}
				/>
				<TextInput
					Id="Count"
					Type="number"
					Step="0.001"
					RowClass="nomargin"
					Value={this.props.Item.Count}
					Icon={this.props.Item.UnitName}
					IconType="text"
					Required={this.props.Item.ProductId !== "" && this.props.Item.ProductId !== -1}
					onChange={(value, id) => this.props.Item.collect(id, value)}
				/>
				<Selectize
					Id="CancelReasonId"
					List={toSelectList(this.props.CancelReasons)}
					RowClass="nomargin"
					Value={this.props.Item.CancelReasonId}
					onChange={(value, id) => this.props.Item.collect(id, value)}
				/>
				<TextInput
					Id="Description"
					RowClass="nomargin"
					Value={this.props.Item.Description}
					onChange={(value, id) => this.props.Item.collect(id, value)}
				/>
				<RemoveIconButton
					onClick={() => this.props.store.removeProduct(this.props.ProductType, this.props.Index)} />
			</>
		)
	}
}
ProductEditItem = observer(ProductEditItem);

class ProductViewItem extends Component {
	render() {
		return(
			<>
				<span className="newProductIcon"></span>
				<span>{this.props.Item.Product}</span>
				<span>{this.props.Item.Count} {this.props.Item.UnitName}</span>
				<span>{this.props.Item.CancelReason}</span>
				<span>{this.props.Item.Description}</span>
				{this.props.ShowAmount &&
					<span>{getRubs(this.props.Item.Amount, true, true)}</span>
				}
				<span className="action"></span>
			</>
		)
	}
}
